/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 * Test for Pipeline trigger by Prakash 13 Feb 26. Can be removed. Second commit now 3.45 PM
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}
window.console.log =() =>{
    
}
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
